import React from 'react';
import { Grid } from '@mui/material';
import { CheckinCheckoutForm } from '../../CheckinCheckoutForm/CheckinCheckoutForm';
import { DocumentUploadSlot } from '../../DocumentUploadSlot/DocumentUploadSlot';
import { DmsAltBox } from 'dmsbasereact';
import { Typography } from '@mui/material';

export const OrderDivergenceFullContainer = ({
    organizationBranches,
    batches,
    handleCheckoutDataChange,
    handleCheckoutSubmitted,
    checkoutData,
    files,
    handleFileSelect,
    existingFiles,
    data,
    handleChange,
    fieldHasError,
    helperText,
    intl,
}) => {
    const orderDivergenceDocsContainer = (
        <DmsAltBox.Card sx={{ mt: 3 }}>
            <DmsAltBox.Header>
                <Typography variant="h6">
                    {intl.get("Evidencia").d("Evidence")}
                </Typography>
            </DmsAltBox.Header>
            <DmsAltBox.Body>
                <Grid container spacing={2} alignItems="stretch">
                    <Grid item xs={12} sm={6}>
                        <DocumentUploadSlot
                            docName="evidencia"
                            file={files.evidencia}
                            onFileSelect={handleFileSelect}
                            existingFile={existingFiles.find(f => f.document_name === 'evidencia')}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <DocumentUploadSlot
                            docName="invoice"
                            file={files.invoice}
                            onFileSelect={handleFileSelect}
                            existingFile={existingFiles.find(f => f.document_name === 'invoice')}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <DocumentUploadSlot
                            docName="evidencia1"
                            file={files.evidencia1}
                            onFileSelect={handleFileSelect}
                            existingFile={existingFiles.find(f => f.document_name === 'evidencia1')}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <DocumentUploadSlot
                            docName="evidencia2"
                            file={files.evidencia2}
                            onFileSelect={handleFileSelect}
                            existingFile={existingFiles.find(f => f.document_name === 'evidencia2')}
                        />
                    </Grid>
                </Grid>
            </DmsAltBox.Body>
        </DmsAltBox.Card>
    );

    return (
        <Grid item xs={12}>
            {orderDivergenceDocsContainer}
            <CheckinCheckoutForm
                organizationBranches={organizationBranches}
                batches={batches}
                mode="devolution"
                hideButton={true}
                onDataChange={handleCheckoutDataChange}
                onCheckoutSubmitted={handleCheckoutSubmitted}
                initialData={{
                    ...checkoutData,
                    ownerEntityPk: checkoutData?.requesting_organization_pk
                }}
                fieldHasError={fieldHasError}
                helperText={helperText}
            />
        </Grid>
    );
};
